import { fetchQuery, graphql } from "relay-runtime"
import {
  AiRequestMetadataInput,
  deCallTranscriptSummarizerQuery as DeCallTranscriptSummarizerQuery,
} from "@/modules/patients/detail/progress-note/services/de/__generated__/deCallTranscriptSummarizerQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query deCallTranscriptSummarizerQuery($aiRequestMetadata: AiRequestMetadataInput!) {
    summarizeCallTranscript: de_summarizeCallTranscript(aiRequestMetadata: $aiRequestMetadata) {
      text
      result
      fileHash
      aiRequestDurationMs
      aiAnonymizationRequestDurationMs
    }
  }
`

export const deCallTranscriptSummarizerQuery = (aiRequestMetadata: AiRequestMetadataInput) => {
  return fetchQuery<DeCallTranscriptSummarizerQuery>(RelayEnvironment, query, {
    aiRequestMetadata,
  }).toPromise()
}
